/**
 * Created by Languagenut on 21/03/2019.
 */


import React from 'react';
import { Navbar, Nav, Button } from 'react-bootstrap';
import Translation from '../store/internationalization-store.js';
import ProductStore from '../store/product-store.js'
import Constants from '../constants.js';
import ProductService from '../services/product-service.js'


export default class Navigation extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {
            eventKey: 8
        };
    }

    componentWillMount() {
        ProductService.getUserData();
        ProductStore.on(Constants.GET_USER_DATA, () => {
            this.setState({ updated: true })
        })
    }

    resources() {
        window.location.href = '/resources/#/Account'
    }

    admin() {
        window.location.href = '/admin'
    }

    getSchoolLogo(accountUID) {
        if (ProductStore.userData == undefined || ProductStore.userData.accountSettings == undefined
            || ProductStore.userData.accountSettings['cefrLogo'] == undefined) {
            return <img src={"./img/logos/schools/oxfordLogo.png"} />;
        }
        return <img src={ProductStore.userData.accountSettings['cefrLogo']} />;
    }

    render() {

        const handleSelect = eventKey => this.setState({ eventKey: eventKey });

        let ButtonOne = <Button onClick={this.admin.bind(this)}>{Translation.get(12651, 'Old admin area')}</Button>
        let ButtonTwo = <Button className="invisable">{Translation.get(12651, 'Old admin area')}</Button>

        try {
            var data = JSON.parse(sessionStorage.chatting)
            var accounts = [
                463372,
                34071,
                469559,
                469560,
                462923,
            ]
            if (accounts.indexOf(Number(data.accountUid)) >= 0) {
                ButtonOne = null;
                ButtonTwo = null;
            }
        }
        catch (e) {
            ButtonOne = <Button onClick={this.admin.bind(this)}>{Translation.get(12651, 'Old admin area')}</Button>
            ButtonTwo = <Button className="invisable">{Translation.get(12651, 'Old admin area')}</Button>
        }


        ButtonOne = null;
        ButtonTwo = null;


        var languagenutAccount = 'https://resources.languagenut.com/resources/#/'
        if (window.location.hostname.indexOf('localhost') > -1 || window.location.hostname.indexOf('beta') > -1 ||
            window.location.hostname.indexOf('alpha') > -1 || window.location.hostname.indexOf('gamma') > -1) {
            languagenutAccount = "https://gamma.languagenut.com/resources/#/";
        }
        var navigations = [];
        var isNormalAccount = true;
        var isExamStuff = true;

        if (isExamStuff == true) {
            navigations = <Nav className="justify-content-left" activeKey={this.state.eventKey} >
                <Navbar.Brand style={{ paddingLeft: "1rem" }} ><a onClick={this.resources.bind(this)} style={{ marginLeft: "15px", paddingRight: "20px" }}>{this.getSchoolLogo(ProductStore.userData.accountUid)}</a></Navbar.Brand>
                <Nav.Link eventKey="8" style={{ marginTop: '18px' }} href="#examTests/list">{Translation.get(0, 'Test Results')}</Nav.Link>
                <Nav.Link eventKey="7" style={{ marginTop: '18px' }} href="#student/administration">{Translation.get(0, 'Licence Management')}</Nav.Link>
                <Nav.Link eventKey="6" style={{ marginTop: '18px' }} href="#settings/establishment">{Translation.get(0, 'Test Information')}</Nav.Link>
                <Nav.Link eventKey="9" style={{ marginTop: '18px' }} href="#videos/helpVideos">{Translation.get(0, 'Help Videos')}</Nav.Link>
                <Navbar.Brand style={{ paddingLeft: "1rem" }} ><a style={{ paddingLeft: "280px" }} onClick={this.resources.bind(this)}> <img src="./logos/languagenut/200px.png"></img></a></Navbar.Brand>
            </Nav>
        } else if (isExamStuff == false && isNormalAccount == true) {
            navigations = <Nav className="justify-content-center" activeKey={this.state.eventKey} >
                <Nav.Link eventKey="4" style={{ marginTop: '18px' }} href="#school/dashboard">{Translation.get(12009, 'School')}</Nav.Link>
                <Nav.Link eventKey="1" style={{ marginTop: '18px' }} href="#class/management">{Translation.get(830, 'Classes')}</Nav.Link>
                <Nav.Link eventKey="7" style={{ marginTop: '18px' }} href="#student/management">{Translation.get(29, 'Students')}</Nav.Link>
                <Nav.Link eventKey="3" style={{ marginTop: '18px' }} href="#assignments/management">{Translation.get(12052, 'Assignments')}</Nav.Link>
                <Navbar.Brand style={{ paddingLeft: "1rem" }} ><a onClick={this.resources.bind(this)}> <img style={{ marginLeft: "-160px", paddingRight: "40px" }} src="./logos/languagenut/200px.png"></img>{this.getSchoolLogo('1')}</a></Navbar.Brand>
                <Nav.Link eventKey="2" style={{ marginTop: '18px' }} href="#library/custom_content">{Translation.get(110, 'Library')}</Nav.Link>
                <Nav.Link eventKey="5" style={{ marginTop: '18px' }} href="#staff">{Translation.get(858, 'Teachers')}</Nav.Link>
                <Nav.Link eventKey="6" style={{ marginTop: '18px' }} href="#settings/establishment">{Translation.get(0, 'Test Information')}</Nav.Link>
            </Nav>
        }

        return <Navbar className="menu_shadow mx-auto" bg="light" expand="lg" onSelect={handleSelect}>

            {ButtonTwo}
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse className="justify-content-center" id="basic-navbar-nav">
                {navigations}
            </Navbar.Collapse>

            &nbsp; &nbsp; &nbsp;
            {ButtonOne}
        </Navbar>
    }
}